import React from 'react'
import { IonicDownloadOutline } from 'maeng-icons'
import { Message } from 'maeng-utils/locale'
import SkillImage from '@/assets/images/banner/skills.png'

const Banner = () => {
  return (
    <div className="flex justify-center items-center h-96 bg-gradient-to-t from-gray-100 from-0% to-white to-30% border-b border-gray-100">
      <div>
        <div className="flex flex-col gap-[35px]">
          <Message
            i18nKey="banner.portfolio.title"
            component="h2"
            className="text-[32px] font-semibold"
          />
        </div>
        <div className="relative">
          <div className="absolute top-5 left-[-110px] mx-auto w-72 text-start">
            <span className="text-base-content/70 inline-block -translate-y-2 -rotate-12">
              Click
            </span>
            <svg
              className="text-base-content/20 inline-block h-8 w-20 rtl:[transform:rotateY(180deg)]"
              viewBox="0 0 45 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1.50244C23.4 -1.69756 38.3333 11.1691 43 18.0024M43 18.0024L38 17.0024M43 18.0024V13.0024"
                stroke="currentColor"
              />
            </svg>
          </div>
          <a className="btn focus:shadow-none btn-primary mt-14" download href="portfolio.pdf">
            <IonicDownloadOutline className="w-6 h-6 mr-1" />
            PORTFOLIO
          </a>
        </div>
      </div>
      <img
        style={{ width: '303.85px', height: '218.63px', marginLeft: '36px' }}
        alt="skills"
        src={SkillImage}
      />
    </div>
  )
}

export default Banner
